export default function Deviantart() {
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.57 3h-3.271l-.326.33-1.544 2.942-.486.327H6.432v4.495h3.03l.27.327-3.3 6.305v3.273h3.272l.327-.33 1.543-2.943.486-.326h5.511v-4.495h-3.03l-.269-.329 3.299-6.303L17.57 3z"
        className="ease-in-out fill-gray-800 group-hover:fill-gray-600 dark:fill-slate-300 dark:group-hover:fill-slate-400"
      />
    </svg>
  )
}
